import { sortBy } from 'lodash-es';

import { services } from 'services/base';
import { AuthMode, HeaderComponent, HeaderItem, HeaderItemType, PreferencesMenuItemType } from 'types';
import { getMainConfig } from 'utils';

const SERVICE_PREFIX = 'appFrame.header';

export const isPreferencesMenuItemsEmpty = () =>
  !services.appFrame.preferences.getItems().filter(({ type }) => type !== PreferencesMenuItemType.DIVIDER).length;

const getHeaderDefaultItems = () => {
  const result: HeaderItem[] = [
    {
      type: HeaderItemType.COMPONENT,
      Component: HeaderComponent.HelpMenu,
      id: 'AppFrame-HelpMenu',
      order: 2000,
    },
  ];

  if (services.appFrame.auth.getAuthMode() !== AuthMode.NoLogin) {
    result.push({
      type: HeaderItemType.COMPONENT,
      id: 'AppFrame-UserInfo',
      Component: HeaderComponent.UserInfo,
      order: 4000,
    });
  }

  if (!isPreferencesMenuItemsEmpty()) {
    result.push({
      type: HeaderItemType.COMPONENT,
      id: 'AppFrame-PreferencesMenu',
      Component: HeaderComponent.PreferencesMenu,
      order: 3000,
    });
  }

  if (getMainConfig('env')) {
    result.unshift({
      id: 'Appframe-DividerAfterEnv',
      type: HeaderItemType.DIVIDER,
      order: 100,
    });
  }

  return sortBy(result, 'order');
};

const initHeaderServices = () => {
  services.registerCollection(SERVICE_PREFIX, getHeaderDefaultItems());

  services.appFrame.preferences.onItemChange((/* reason */) => {
    services.appFrame.header.setDefaultItems(getHeaderDefaultItems());
  });

  services.appFrame.config.onMainConfigChange((/* newConfig */) => {
    services.appFrame.header.setDefaultItems(getHeaderDefaultItems());
  });
};

export default initHeaderServices;
